"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenuItem = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var DropdownMenuTrigger_1 = __importDefault(require("./DropdownMenuTrigger"));
var react_2 = require("@emotion/react");
var defaultProps = {
    closeOnClick: true,
    align: 'right',
};
var getCSSRules = function (_a, styles, menuStyles) {
    var colors = _a.colors, borderRadius = _a.borderRadius;
    return ({
        dropdownMenu: __assign({ position: 'relative', width: 32, height: 32, zIndex: 101 }, styles),
        menu: __assign({ position: 'absolute', top: '100%', right: 0, padding: '6px 0', backgroundColor: colors.Grey[0], color: colors.Grey[1000], borderRadius: borderRadius.sm, boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)", pointerEvents: 'none', opacity: 0, transition: 'all ease-in .1s, opacity ease .2s', transform: 'translateY(-5px)' }, menuStyles),
        menuOpen: {
            pointerEvents: 'all',
            opacity: 1,
            transform: 'translateY(0)',
        },
        alignLeft: {
            right: 'auto',
            left: 0,
        },
        overlay: {
            position: 'fixed',
            zIndex: 100,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
        },
        alignBottom: {
            top: 'auto',
            bottom: '100%',
        },
    });
};
var DropdownMenu = function (_a) {
    var style = _a.style, children = _a.children, align = _a.align, closeOnClick = _a.closeOnClick, verticalAlign = _a.verticalAlign, triggerComponent = _a.triggerComponent, isOpenInitially = _a.open, onOpen = _a.onOpen, onClose = _a.onClose, menuStyle = _a.menuStyle;
    var _b = (0, react_1.useState)(isOpenInitially), open = _b[0], setOpen = _b[1];
    var handleClose = function () {
        onClose && onClose();
        setOpen(false);
    };
    var handleToggle = function () {
        if (open) {
            onClose && onClose();
        }
        else {
            onOpen && onOpen();
        }
        setOpen(!open);
    };
    var theme = (0, react_2.useTheme)();
    var styles = getCSSRules(theme, style, menuStyle);
    return ((0, jsx_runtime_1.jsx)(react_2.ClassNames, { children: function (_a) {
            var _b;
            var cx = _a.cx, css = _a.css;
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [open && (0, jsx_runtime_1.jsx)("div", { onClick: handleClose, css: styles.overlay }, void 0), (0, jsx_runtime_1.jsxs)("div", __assign({ className: cx(css(styles.dropdownMenu), { 'menu-open': open }) }, { children: [(0, jsx_runtime_1.jsx)(DropdownMenuTrigger_1.default, { onClick: handleToggle, open: !!open, component: triggerComponent }, void 0), (0, jsx_runtime_1.jsx)("div", __assign({ onClick: function () { return closeOnClick && handleClose(); }, className: cx(css(styles.menu), (_b = {},
                                    _b[css(styles.alignLeft)] = align === 'left',
                                    _b[css(styles.alignBottom)] = verticalAlign === 'bottom',
                                    _b[css(styles.menuOpen)] = open,
                                    _b)) }, { children: children }), void 0)] }), void 0)] }, void 0));
        } }, void 0));
};
DropdownMenu.defaultProps = defaultProps;
exports.default = DropdownMenu;
var DropdownMenuItem_1 = require("./DropdownMenuItem");
Object.defineProperty(exports, "DropdownMenuItem", { enumerable: true, get: function () { return __importDefault(DropdownMenuItem_1).default; } });
//# sourceMappingURL=index.js.map